import { useAppQuery } from '@/helpers/api/query'
import { formatInTimeZone } from 'date-fns-tz'

import { createInstance } from '@/helpers/api/base'
import { useDateStore } from '@/components/DateInput'
import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'
import { LogPermission } from '@/types/logs'

const GET_LOG_PERMISSIONS_KEY = 'LOG_PERMISSIONS'

export const useGetLogPermissions = () => {
    const { role } = useAuthStore()
    const { date } = useDateStore()
    const formattedDate = formatInTimeZone(date, 'UTC', "yyyy-MM-dd'T'HH:mm:ss")

    return useAppQuery<LogPermission[]>({
        queryKey: [GET_LOG_PERMISSIONS_KEY, formattedDate],
        queryFn: () =>
            createInstance({
                url: '/mileage-period/coding-period/timestamp',
                method: 'GET',
                params: {
                    timestamp: formattedDate,
                },
            }),
        enabled: role !== Role.Reader,
        staleTime: Infinity,
    })
}
